// extracted by mini-css-extract-plugin
export var headerXL = "Quote-module--headerXL--1U0ME";
export var headerL = "Quote-module--headerL--3yt7j";
export var headerM = "Quote-module--headerM--3qO5I";
export var headerS = "Quote-module--headerS--JznzU";
export var headerXS = "Quote-module--headerXS--3IGeE";
export var blogHeaderXL = "Quote-module--blogHeaderXL--32tKp";
export var blogHeaderL = "Quote-module--blogHeaderL--h8ffc";
export var blogHeaderM = "Quote-module--blogHeaderM--1UOij";
export var blogHeaderS = "Quote-module--blogHeaderS--2RUuI";
export var blogHeaderXS = "Quote-module--blogHeaderXS--1fHMT";
export var headerPreamble = "Quote-module--headerPreamble--2RnjE";
export var preHeader = "Quote-module--preHeader--1g4y1";
export var textNormal = "Quote-module--textNormal--3GOpQ";
export var textSmall = "Quote-module--textSmall--3H_F5";
export var textSmallAlternate = "Quote-module--textSmallAlternate--Z69qB";
export var legend = "Quote-module--legend--22bEl";
export var caption = "Quote-module--caption--3n4yd";
export var gradientBackground = "Quote-module--gradientBackground--1PIs2";
export var ellipsis = "Quote-module--ellipsis--2fSGG";
export var globalContainer = "Quote-module--globalContainer--23e3k";
export var maxWidth = "Quote-module--maxWidth--1nxQ3";
export var clipBottom = "Quote-module--clipBottom--8Nxgu";
export var clipTopBottom = "Quote-module--clipTopBottom--2EkoU";
export var quote = "Quote-module--quote--1jO6w";
export var alignCenter = "Quote-module--alignCenter--3l64b";
export var alignRight = "Quote-module--alignRight--wBigW";
export var text = "Quote-module--text--2L5B2";
export var title = "Quote-module--title--83RKT";
export var ch2 = "Quote-module--ch2--qR5bL";
export var ch2Container = "Quote-module--ch2-container--bOILl";